// FILENAME: frontend/src/constants/programs.js
export const PROGRAMS = [
  'Website',
  'Chat',
  'Trade',
  'SEO',
  'Digital Ad Sales',
  'Digital Ad Service',
];



